module.exports = __webpack_public_path__ + "static/media/x_icon_black.d792b1cd.svg";